import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  addFranchise,
  getFranchises,
  toggleFranchiseStatus,
  editFranchise,
  deleteFranchise,
  getLocationById,
} from "../../services/franchiseService";
import toast from "../../utils/toast";

const initialState = {
  franchiseData: null,
  allFranchises: null,
  toggledFranchise: null,
  updatedFranchise: null,
  deletedFranchise: null,
  locationById: null,
  loading: false,
};

const franchiseSlice = createSlice({
  name: "franchise",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(addFranchise?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.franchiseData = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getFranchises?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.allFranchises = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(toggleFranchiseStatus?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.toggledFranchise = action?.payload?.data;
        toast.success(action?.payload?.message, {
          style: {
            background: "#E6F7FB",
            color: "#007EA7",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            padding: "12px 16px",
          },
          progressStyle: {
            background: "#007EA7",
          },
          icon: "✅",
        });
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(editFranchise?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.updatedFranchise = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(deleteFranchise?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.deletedFranchise = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getLocationById?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.locationById = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder
      .addMatcher(
        isAnyOf(
          addFranchise?.pending,
          getFranchises?.pending,
          toggleFranchiseStatus?.pending,
          editFranchise?.pending,
          deleteFranchise?.pending,
          getLocationById?.pending
        ),
        (state, action) => {
          // Skip global loading overlay for silent searches (navbar)
          if (action?.meta?.arg?.silent === true) return;
          state.loading = true;
        }
      )
      .addMatcher(
        isAnyOf(
          addFranchise?.rejected,
          getFranchises?.rejected,
          toggleFranchiseStatus?.rejected,
          editFranchise?.rejected,
          deleteFranchise?.rejected,
          getLocationById?.rejected
        ),
        (state, action) => {
          state.loading = false;
          if (action?.meta?.arg?.silent === true) return;
          if (action?.payload?.blockedMerchant === true) return;
          toast.error(action?.payload?.message);
        }
      );
  },
});

export const {} = franchiseSlice?.actions;
export default franchiseSlice?.reducer;
